import { colors } from '../../constants';

export const Label = ({ label }) => {
  if (!label) return null;
  return <div style={{ fontSize: 14, fontWeight: 'bold', color: colors.gentleGray, marginBottom: 5 }}>{label}</div>;
};
